<div class="job-posts placements agreements margin-top-service-30px">
  <div class="card skillassest-form">
    <!--<div class="card-header wh-header card-title-schedule-bb card-title-schedule-bl padding-l-8px  padding-bottom padding-top-5">
      Services Configuration
    </div>-->



  </div>
  <div class="card-body padding-top padding-left-0px padding-right-0px">
    <div class="row">

      <div class="position-fixed-service border-right2 padding-right-0px">
        <div class="card">

          <div class="card-header wh-header header3 padding-right-32px bk-color-light padding-bottom-0px">
            <div class="row margin-top10px margin-left-20px  nav-link-hand" (click)="back()">
             
              <label class="wh-header font-weight-normal card-title-schedule-bl border-radius-4px padding-top-10px padding-bottom-4px margin-bottom-0px bk-color-light">
                Lab Departments</label>
                <a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Tests"
                    *ngIf="ShowIcon" (click)="back()" ><i class="fas fa-angle-double-left font-size-19px"></i></a>
             
            </div>
            <!--<div class="row margin-left-zero margin-top-10">
              Categories
            </div>-->



          </div>
          <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-light">
            <div class="row border-top border-bottom padding-top-10px padding-bottom-10px margin-right-0px margin-left16px">
              <div class="col-md-8 padding-right-0px padding-left-0px margin-left-17px">
                <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
              </div>
              <div class="col-md-2 padding-top-2px padding-left-10px">
                <button type="button" class="btn btn-new btn-sm" tooltip="Add"><i class="fas fa-plus nav-link-hand"></i></button>
                <!--<button class="btn btn-new btn-sm" tooltip="Add" type="button" ><i class="fas fa-plus-square nav-link-hand  font-size-20px"></i></button>-->
              </div>
              

            </div>
            <div>
              <div class="chatsd product-chart-wrapper product-chat-width-97 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                <div class="row border-bottom rowfor margin-left16px nav-link-hand edit_hover_class" (click)="Selectedlab(l)" *ngFor="let l of pdata">

                  <div class="col-md-10">

                    <label class="margin-bottom-0px nav-link-hand font-size-13px margin-left-5px">{{l.CategoryName || l.categoryName}}</label>
                  </div>
                  <div class="col-md-2 padding-left-0px">
                    <a> <i class="fas fa-pencil-alt nav-link-hand"></i></a>
                  </div>

                </div>

                <!--<div class="row border-bottom rowfor margin-left16px nav-link-hand edit_hover_class" (click)="viewservice1()">

                  <div class="col-md-10">

                    <label class="margin-bottom-0px nav-link-hand font-size-13px margin-left-5px">Harmonal Assay</label>
                  </div>
                  <div class="col-md-2 padding-left-0px">
                    <a> <i class="fas fa-pencil-alt nav-link-hand"></i></a>
                  </div>

                </div>-->

              </div>
            </div>

          </div>
          
        </div>
      </div>
      <div class="offset-md-2 col-md-10 padding-left-42px" *ngIf="ShowService">
        <div class="card">

        </div>
        <div class="row" >
          <div class="col-md-12 padding-left-0px">
            <div class="card">
              <div class="card-header wh-header border-bottom ">
                <div class="row">
                  <div class="col-md-3 padding-right-0px"><label class="label-size-2 font-color-secondary">Selected Department</label></div>:
                  <div class="col-md-4 text-align-left"><label class="label-size-2">{{SelectedlabDetails ? (SelectedlabDetails.CategoryName || SelectedlabDetails.categoryName || SelectedlabDetails.Name || SelectedlabDetails.name || SelectedlabDetails.ServiceName || SelectedlabDetails.serviceName || SelectedlabDetails.DisplayName || SelectedlabDetails.displayName || SelectedlabDetails.Category || SelectedlabDetails.category || 'All Categories') : 'All Categories'}}</label></div>
                  <div class="col-md-4 padding-left-0px">
                    <div class="row margin-left-zero margin-right-0px">
                      <div class="col-md-8 padding-right-0px float-left">
                        <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                      </div>

                      <div class="col-md-3 padding-right-8px padding-bottom-4px padding-top-4px rowfor1">
                        <a class="float-right" (click)="addtestmodal()"><i class="fas fa-plus nav-link-hand"></i><label class="margin-bottom-0px padding-left-5px font-size-18px">Tests</label></a>
                      </div>


                    </div>
                  </div>

                </div>
              </div>
              <div class="card-body">
                <div class="table-component">
                  <div class="table-responsive overflow-x-hidden">


                    <table class="table table-striped margin-left-zero">

                      <thead class="">
                        <tr>
                          <th class="td-width-3px">Code</th>

                          <th class="">Name</th>

                          <th class="">Lab Department </th>
                          <th class="">Profile</th>



                          <th class="">Service Code</th>
                         
                        </tr>
                      </thead>
                      <tbody class="table-body">
                        <tr *ngFor="let l of CurrentTestsByLabCodeController">
                          <td><a (click)="ViewServiceDetails(l)" class="nav-link-hand table-anchor">{{l.Code !== undefined ? l.Code : (l.code !== undefined ? l.code : (l.TestCode !== undefined ? l.TestCode : l.testCode))}}</a></td>
                          <td><a (click)="ViewServiceDetails(l)" class="nav-link-hand table-anchor">{{l.Name || l.name || l.TestName || l.testName}}</a></td>
                          <td class="">
                            <a class="nav-link-hand table-anchor">{{l.CategoryName || l.categoryName || l.LabDepartmentName || l.labDepartmentName}}</a>
                          </td>
                          <td class="">
                            <a class="nav-link-hand table-anchor">{{l.ProfileName || l.profileName || (l.AgeProfile == 1 || l.ageProfile == 1 ? 'Female' : l.AgeProfile == 2 || l.ageProfile == 2 ? 'Male' : 'All')}}</a>
                          </td>
                          <td class="">
                            <a class="nav-link-hand table-anchor">{{l.ServiceCode !== undefined ? l.ServiceCode : l.serviceCode}}</a>
                          </td>
                        </tr>

                        <!--<tr>
                          <td><a (click)="ViewServiceDetails()" class="nav-link-hand table-anchor">2</a></td>
                          <td><a (click)="ViewServiceDetails()" class="nav-link-hand table-anchor">ACA-IGM (ANTI-CARDIOLIPIN IGM)</a></td>



                          <td class="">
                            <a class="nav-link-hand table-anchor">Harmonal Assay</a>

                          </td>

                          <td class="">
                            <a class="nav-link-hand table-anchor">Female</a>

                          </td>

                          <td class="">
                            <a class="nav-link-hand table-anchor">17</a>

                          </td>


                        </tr>

                        <tr>
                          <td><a (click)="ViewServiceDetails()" class="nav-link-hand table-anchor">1</a></td>
                          <td><a (click)="ViewServiceDetails()" class="nav-link-hand table-anchor">ACA IGG</a></td>



                          <td class="">
                            <a class="nav-link-hand table-anchor">Serology</a>

                          </td>

                          <td class="">
                            <a class="nav-link-hand table-anchor">Female</a>

                          </td>

                          <td class="">
                            <a class="nav-link-hand table-anchor">16</a>

                          </td>


                        </tr>

                        <tr>
                          <td><a (click)="ViewServiceDetails()" class="nav-link-hand table-anchor">2</a></td>
                          <td><a (click)="ViewServiceDetails()" class="nav-link-hand table-anchor">ACA-IGM (ANTI-CARDIOLIPIN IGM)</a></td>



                          <td class="">
                            <a class="nav-link-hand table-anchor">Harmonal Assay</a>

                          </td>

                          <td class="">
                            <a class="nav-link-hand table-anchor">Female</a>

                          </td>

                          <td class="">
                            <a class="nav-link-hand table-anchor">17</a>

                          </td>


                        </tr>

                        <tr>
                          <td><a (click)="ViewServiceDetails()" class="nav-link-hand table-anchor">1</a></td>
                          <td><a (click)="ViewServiceDetails()" class="nav-link-hand table-anchor">ACA IGG</a></td>



                          <td class="">
                            <a class="nav-link-hand table-anchor">Serology</a>

                          </td>

                          <td class="">
                            <a class="nav-link-hand table-anchor">Female</a>

                          </td>

                          <td class="">
                            <a class="nav-link-hand table-anchor">16</a>

                          </td>


                        </tr>-->

                      </tbody>

                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

     
      <div class="offset-md-2 col-md-10 padding-left-42px">

        <testinformation *ngIf="SelectedService"
                         [ServiceCode]="SelectedService.ServiceCode !== undefined ? SelectedService.ServiceCode : (SelectedService.serviceCode !== undefined ? SelectedService.serviceCode : (SelectedService.Code !== undefined ? SelectedService.Code : SelectedService.code))"
                         [ServiceName]="SelectedService.Name || SelectedService.name || SelectedService.ServiceName || SelectedService.serviceName || ''"
                         [DepartmentName]="SelectedlabDetails ? (SelectedlabDetails.CategoryName || SelectedlabDetails.categoryName || SelectedlabDetails.Name || SelectedlabDetails.name || SelectedlabDetails.DisplayName || SelectedlabDetails.displayName || SelectedlabDetails.Category || SelectedlabDetails.category || '') : ''"
                         [ShowService]="ShowService">
        </testinformation>
      </div>

      <!--<div class="row" *ngIf="SelectedService">

  TESTING  {{SelectedService.Code}}
  </div>-->



    </div>
      </div>

    </div>


